import { Box } from '@mui/material'
import RecursiveProperty from './RenderJSON'
import { camelCaseFormatter } from './formatters/camelCase'
import { useTranslation } from 'react-i18next'
import { BDC_convertLevelToHumanFriendly } from './formatters/negativeMedia'

export const mapNegativeMedia = (data) => {
  const mappedData = data?.reduce((result, item) => {
    const title = item['Title']
    result[title] = { ...item }
    delete result[title]['Title']
    return result
  }, {})

  return { NewsItems: mappedData }
}

export const RenderNegativeMedia = (data, theme) => {
  const { t } = useTranslation(['common', 'messages'])

  const notRenderKeys = ['NewsItems', 'Next', 'SearchLabels', 'EntityStatistics', 'TotalPages', 'MediaExposureLevel', 'CelebrityLevel', 'UnpopularityLevel']

  return (
    <Box className="accordion-jap" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06' }}>
      {data && (
        <box>
          {/*here we'll render the MediaExposureLevel, CelebrityLevel, UnpopularityLevel*/}
          <Box className="accordion-jap-row">
            <span className="accordion-jap-title">{t('common:mediaExposureLevel')}: </span>
            <p>{ BDC_convertLevelToHumanFriendly(data.MediaExposureLevel, t)}</p>
          </Box>
          <Box className="accordion-jap-row">
            <span className="accordion-jap-title">{t('common:celebrityLevel')}: </span>
            <p>{BDC_convertLevelToHumanFriendly(data?.CelebrityLevel, t) }</p>
          </Box>
          <Box className="accordion-jap-row">
            <span className="accordion-jap-title">{t('common:unpopularityLevel')}: </span>
            <p>{BDC_convertLevelToHumanFriendly(data?.UnpopularityLevel, t)}</p>
          </Box>
        </box>
      )}
      {data &&
        Object.entries(data)?.map(([key, value]) => {
          return (
            <Box key={key}>
              {!notRenderKeys.includes(key) && (
                <Box className="accordion-jap-row">
                  <span className="accordion-jap-title">{camelCaseFormatter(key)}: </span>
                  <p>{value ?? '---'}</p>
                </Box>
              )}
            </Box>
          )
        })}
      <RecursiveProperty property={data?.SearchLabels} excludeBottomBorder={false} rootProperty={true} />
      <RecursiveProperty property={data?.EntityStatistics} excludeBottomBorder={false} rootProperty={true} />
      <RecursiveProperty property={mapNegativeMedia(data?.NewsItems)} excludeBottomBorder={false} rootProperty={true} />
    </Box>
  )
}
